import React from "react";
import Loader from "../img/loader.gif";

const Loading = () => {
  return <img src={`${Loader}`} style={{ height: "30px" }}></img>;
};

export default Loading;
